module.exports = {
	"config": {
		"siteTitle": "React Sharingbuttons",
		"baseColor": "#1B5E20",
		"linkPrefix": "/react-sharingbuttons",
		"docPages": [
			"/docs/",
			"/docs/getting-started/",
			"/docs/how-to-run/",
			"/docs/some-react-code/",
			"/docs/the-next-step/",
			"/docs/conclusion/"
		],
		"repoUrl": "https://github.com/caspg/react-sharingbuttons",
		"siteUrl": "https://caspg.github.io/react-sharingbuttons"
	},
	"relativePath": "",
	"pages": [
		{
			"file": {
				"root": "",
				"dir": "",
				"base": "_template.jsx",
				"ext": "jsx",
				"name": "_template",
				"extname": ".jsx",
				"basename": "_template.jsx",
				"dirname": "",
				"stem": "_template",
				"path": "_template.jsx",
				"absolute": "/Users/kacper/workspace/react-sharingbuttons/www/_template.jsx",
				"isAbsolute": false
			},
			"requirePath": "_template.jsx",
			"templatePath": "//",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "",
				"base": "404.md",
				"ext": "md",
				"name": "404",
				"extname": ".md",
				"basename": "404.md",
				"dirname": "",
				"stem": "404",
				"path": "404.md",
				"absolute": "/Users/kacper/workspace/react-sharingbuttons/www/404.md",
				"isAbsolute": false
			},
			"requirePath": "404.md",
			"path": "/404.html",
			"data": {
				"path": "/404.html"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "",
				"stem": "index",
				"path": "index.md",
				"absolute": "/Users/kacper/workspace/react-sharingbuttons/www/index.md",
				"isAbsolute": false
			},
			"requirePath": "index.md",
			"path": "/",
			"data": {}
		}
	]
}


/*****************
 ** WEBPACK FOOTER
 ** ../config.toml
 ** module id = 378
 ** module chunks = 0
 **/